/* eslint-disable import/no-unused-modules */
export const HTTP_STATUS_2XX = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE: 203,
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,
  IM_USED: 226,
};

export const HTTP_STATUS_4XX = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
};

export const HTTP_STATUS_5XX = {
  INTERNAL_ERROR: 500,
};

export const HTTP_STATUS_6XX = {
  PASSWORD_EXPIRED: 663,
};
